import Step from '~/src/features/mania/components/Step';
import { stepsData } from '~/src/features/mania/data';

import * as ST from './styled';

const HowItWork = (): JSX.Element => {
    return (
        <ST.Container>
            <ST.StepsTitle>Как это работает</ST.StepsTitle>
            <ST.StepsBlock>
                {stepsData.map(step => (
                    <Step
                        key={step.id}
                        stepData={step}
                        data-test='mania-step'
                    />
                ))}
            </ST.StepsBlock>
        </ST.Container>
    );
};

export default HowItWork;
